/*
 * Copyright (c) 2025. World Wide Generation Ltd
 */

import { ListItemNode, ListNode } from '@lexical/list';
import { HeadingNode } from '@lexical/rich-text';
import { defaultTheme } from '@features/rich-text-editor/themes/defaultTheme';
import { handleRouteError } from '../../logger';
import { VariableNode } from './nodes/VariableNode';
import type { VariableDefinition, VariableMap } from './types';
import { VariableKey } from './types';

export const defaultConfig = {
  namespace: 'RichTextEditor',
  theme: defaultTheme,
  onError: (error: Error) => {
    handleRouteError(error);
  },
  nodes: [ListNode, ListItemNode, HeadingNode, VariableNode],
};

export const VARIABLE_DEFINITIONS: VariableDefinition[] = [
  {
    key: VariableKey.CURRENT_SUBSIDIARY,
    label: 'Current Subsidiary Name',
    icon: 'fa-building',
    description: 'The name of the current subsidiary',
  },
  {
    key: VariableKey.ROOT_SUBSIDIARY,
    label: 'Root Subsidiary Name',
    icon: 'fa-sitemap',
    description: 'The name of the root organization',
  },
  {
    key: VariableKey.PERIOD,
    label: 'Period',
    icon: 'fa-calendar',
    description: 'The report period type from settings',
  },
  {
    key: VariableKey.DURATION,
    label: 'Duration',
    icon: 'fa-clock',
    description: 'The calculated time duration based on period settings',
  },
];

/**
 * Default variable map with fallback values for missing data
 * Using '-' as the default fallback to clearly indicate missing values
 */
export const EMPTY_VARIABLE_MAP: VariableMap = {
  [VariableKey.CURRENT_SUBSIDIARY]: '-',
  [VariableKey.ROOT_SUBSIDIARY]: '-',
  [VariableKey.PERIOD]: '-',
  [VariableKey.DURATION]: '-',
};

